import { apiGet, apiPatch, apiPost } from "./client";
import type { CrmConnectionStatus } from "@sales-ops-amplify/shared";

export interface SalesforceSyncResult extends CrmConnectionStatus {
  message?: string;
  companies: {
    created: number;
    updated: number;
    fetched?: number;
    truncated?: boolean;
  };
  contacts: {
    created: number;
    updated: number;
    fetched?: number;
    truncated?: boolean;
  };
  deals: {
    created: number;
    updated: number;
    fetched?: number;
    truncated?: boolean;
  };
  instanceUrl?: string;
  warnings?: string[];
}

export async function getSalesforceStatus(): Promise<CrmConnectionStatus> {
  return apiGet<CrmConnectionStatus>("/api/crm/salesforce/status");
}

export async function startSalesforceOAuth(): Promise<{ url: string }> {
  return apiGet<{ url: string }>("/api/crm/salesforce/oauth/start");
}

export async function disconnectSalesforce(): Promise<{ connected: boolean }> {
  return apiPost("/api/crm/salesforce/disconnect");
}

export async function syncSalesforce(): Promise<SalesforceSyncResult> {
  return apiPost<SalesforceSyncResult>("/api/crm/salesforce/sync");
}

export async function saveSalesforceStageMap(
  stageMap: Record<string, string>,
): Promise<{ stageMap: Record<string, string>; message?: string }> {
  return apiPatch("/api/crm/salesforce/stage-map", { stageMap });
}
